import React from 'react';
import browserAnalytics from '../index'; // React hooks/components can use this context to access an analytics
// instance.
//
// This specific context will be used in web applications. Its default value
// is the default browser instance of analytics.
//
// During SSR, nw-app-module provides a server-configured instance of analytics
// with this context.

var AnalyticsContext = React.createContext(browserAnalytics); // There is a React Native version of this file adjacent to this one,
// called `AnalyticsContext.native.js`
// Start there if you are working on react-native.

export default AnalyticsContext;